import React from "react"
import { useLocation } from "react-router"

const useSearchQuery = (): URLSearchParams => {
  const { search } = useLocation()
  return React.useMemo(() => new URLSearchParams(search), [search])
}

export default useSearchQuery
